/**
 * Manual order artwork caps (Phase 104, BLU-1450, D-10 / D-25): the one copy.
 * The server enforces them at mint and commit (image-work.ts,
 * artwork.service.ts); the browser checks them first (trim-image.ts) so a
 * coordinator never waits on an upload the server would refuse.
 */
/** Artwork: at most 60,000,000 pixels in total (decoded RGBA ~240 MB). */
export const MANUAL_ARTWORK_MAX_PIXELS = 60_000_000;
/** Artwork: at most 12000 px on either side. */
export const MANUAL_ARTWORK_MAX_SIDE_PX = 12_000;
/** Mockup: at most 6000 px on either side. */
export const MANUAL_MOCKUP_MAX_SIDE_PX = 6_000;
/** Artwork file: at most 100 MB. */
export const MANUAL_ARTWORK_MAX_BYTES = 100 * 1024 * 1024;
/** Mockup file: at most 15 MB. */
export const MANUAL_MOCKUP_MAX_BYTES = 15 * 1024 * 1024;
